module.exports = __webpack_public_path__ + "img/icon6.c78f3c45.c78f3c45.svg";